import OriginalButton from './Button';
import Text from './Text';
const Button = OriginalButton;
Button.Text = Text;
export default Button;
